import { Row, Col, Input, Modal } from "antd";
import { useState, useEffect } from "react";
import CustomerGridItem from "../../components/CustomerGrid";
import CircularProgress from "../../components/CircularProgress";
import { GetCustomers } from "../../API/customer";
import { GetWithExpiry } from "../../util/sessionManager";
import Classes from "./index.module.css";
const Search = Input.Search;

const ErrorModal = Modal.error;

export default function Customers() {
  const [customers, setCustomers] = useState(GetWithExpiry("customers")?GetWithExpiry("customers"):[]);
  const [displayedCustomers, setDisplayedCustomers] = useState(
    customers ? customers : []
  );
  const [Loading, setLoading] = useState(false);
  useEffect(() => {
    if (!customers.length) {
      setLoading(false);
      GetCustomers()
        .then((i) => {
          if (i) {
            setCustomers(GetWithExpiry("customers"));
            setDisplayedCustomers(GetWithExpiry("customers"));
          }
        })
        .finally(() => {
          setLoading(false);
        })
        .catch((i) => {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگان انجام عمیلات رخداد" + i,
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        });
    }
  }, [customers]);
  const onSearch = (value, _e, info) => {
    setDisplayedCustomers(
      customers.filter((i) => {
        if (
          i.name.toString().includes(value) ||
          i.id.toString().includes(value) ||
          i.address.toString().includes(value)
        ) {
          return i;
        }
      })
    );
  };
  return (
    <>
      <Row className={Classes.searchForm}>
        <Search
          placeholder="جستوجو نام و کد و آدرس"
          onSearch={onSearch}
          allowClear
          enterButton
        />
      </Row>
      <Row>
        {Loading && <CircularProgress />}
        {displayedCustomers.map((i) => {
          return (
            <Col span={24}>
              <CustomerGridItem {...i} />
            </Col>
          );
        })}
      </Row>
    </>
  );
}
